import { Reducer } from 'redux';
import { CorporateActionsDataState } from 'widgets/corpActions/store/data/CorporateActionsDataState';
import {
    CorpActionsActionType,
    CorporateActionsAction,
} from 'widgets/corpActions/store/data/actions';

export const corporateActionsDataReducer: Reducer<
    CorporateActionsDataState,
    CorporateActionsAction
> = (state = {}, action) => {
    switch (action.type) {
        case CorpActionsActionType.CORP_ACTIONS_CLEAR_DATA: {
            const nextState = { ...state };
            delete nextState[action.payload!.requestKey];
            return nextState;
        }
        case CorpActionsActionType.CORP_ACTIONS_HANDLE_RESPONSE: {
            const nextState = { ...state };
            nextState[action.payload!.requestKey] = action.payload!.response;
            return nextState;
        }
        case CorpActionsActionType.CORP_ACTIONS_HANDLE_ERROR: {
            const nextState = { ...state };
            nextState[action.payload!.requestKey] =
                nextState[action.payload!.requestKey] || {};
            nextState[action.payload!.requestKey].errors = [
                action.payload!.error,
            ];
            return nextState;
        }
    }
    return state;
};
